import '../stylesheets/currency_conversion.scss'

const formParams = () => {
  const fromCurrency = document.getElementById('from_currency').value.toLowerCase();
  const toCurrency = document.getElementById('to_currency').value.toLowerCase();
  const amount = document.getElementById('amount').value.toLowerCase();

  const conversionPath = `${fromCurrency}-to-${toCurrency}`.toLowerCase();

  const value = `${window.location.origin}/currency-converter/${conversionPath}/?amount=${amount}`;
  return value;
}

const main = () => {
  const submit = document.getElementById('submit');

  submit.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    window.location.href = formParams();
  });
};

document.addEventListener("DOMContentLoaded", () => {
  main();
});
